/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Checkbox,
  Flex,
  Link,
  Space,
  Switch,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React from 'react';
import customConfig from 'src/config';
import { Trans, useTranslation } from 'react-i18next';
import {
  FormHeaderFieldList,
  FormLabel,
  FormList,
  TitleLabel,
} from 'src/components/Common/FormComponent';
import EditableList from 'src/components/EditableList';
import { generalExport } from 'src/pages/Policy/utils/fns';
import {
  ExchangeOnlinePolicyItem,
  HeaderOperatorEnum,
} from 'src/pages/Policy/utils/types';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import {
  wtpApprovedHeaderListSelector,
  wtpApprovedSenderEmailEntriesSelector,
  wtpApprovedUrlListEntriesSelector,
  wtpBlockedUrlListEntriesSelector,
  wtpTocApprovedUrlListSelector,
} from '@Policy/store/filters/webReputation';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import ImportModal from '../../Components/ImportModal';
import { PolicyTypeEnum } from '@Policy/utils/constants';
import { t } from 'i18next';

export const WtpSenders = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const { t } = useTranslation();
  // get state from store
  const wtpApprovedSenderEmailEnabled = policySelector(
    (s) => s.tmWebthreatprotections.wtpApprovedSenderEmailEnabled
  );
  const approvedSenderList = contextSelector(
    wtpApprovedSenderEmailEntriesSelector,
    isEqual
  );
  // config
  const approvedListMaxCount = contextSelector(
    (s) => s.config.limitation.approvedListMaxCount
  );
  // get action from store
  const setWtpState = contextSelector((s) => s.setWtpState);
  const addWtpApprovedSender = contextSelector((s) => s.addWtpApprovedSender);
  const removeWtpApprovedSender = contextSelector(
    (s) => s.removeWtpApprovedSender
  );
  const importWtpApprvoedSender = contextSelector(
    (s) => s.importWtpApprvoedSender
  );
  // local state
  // approved sender list
  // status change
  const handleWtpApprovedSenderEmailEnabledChange = React.useCallback(() => {
    setWtpState({
      wtpApprovedSenderEmailEnabled: wtpApprovedSenderEmailEnabled ? 0 : 1,
    });
  }, [wtpApprovedSenderEmailEnabled]);
  // export
  const handleApporvedSenderListExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-sender-list',
    });
  }, []);
  // import
  const [
    isApprovedSenderImportModalVisible,
    setIsApprovedSenderImportModalVisible,
  ] = React.useState(false);
  const handleApprovedSenderImportModalClose = React.useCallback(() => {
    setIsApprovedSenderImportModalVisible(false);
  }, []);
  const handleApprovedSenderImportModalOpen = React.useCallback(() => {
    setIsApprovedSenderImportModalVisible(true);
  }, []);
  const handleApprovedSenderImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importWtpApprvoedSender(entries as string[]);
    setIsApprovedSenderImportModalVisible(false);
  }, []);
  useWhyDidYouUpdate('Senders', {
    wtpApprovedSenderEmailEnabled,
    approvedSenderList,
    isApprovedSenderImportModalVisible,
  });
  return (
    <>
      <TitleLabel title={t('policy.title.senders')} />
      <FormList
        onAdd={addWtpApprovedSender}
        onDelete={removeWtpApprovedSender}
        onExport={handleApporvedSenderListExport}
        onImport={handleApprovedSenderImportModalOpen}
        list={approvedSenderList}
        limit={approvedListMaxCount}
        status={!!wtpApprovedSenderEmailEnabled}
        setStatus={handleWtpApprovedSenderEmailEnabledChange}
        label={t('policy.approvedSenderList.title')}
        description={t('policy.approvedSenderList.supportWildcardDesc')}
      />
      <ImportModal
        isVisible={isApprovedSenderImportModalVisible}
        onClose={handleApprovedSenderImportModalClose}
        onImport={handleApprovedSenderImport}
      />
    </>
  );
};
export const WtpUrls = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const { t } = useTranslation();
  // get state from store
  const policyType = policySelector((s) => s.policyType);
  // urls
  const wtpApprovedUrlListEnabled = policySelector(
    (s) => s.tmWebthreatprotections.wtpApprovedUrlListEnabled
  );
  const wtpInternalDomainToApproveUrl = policySelector(
    (s) => s.tmWebthreatprotections.wtpInternalDomainToApproveUrl
  );
  const approvedUrlList = contextSelector(
    wtpApprovedUrlListEntriesSelector,
    isEqual
  );
  const wtpBlockedUrlListEnabled = policySelector(
    (s) => s.tmWebthreatprotections.wtpBlockedUrlListEnabled
  );
  const blockedUrlList = contextSelector(
    wtpBlockedUrlListEntriesSelector,
    isEqual
  );
  // config
  const blockedUrlMaxCount = contextSelector(
    (s) => s.config.limitation.blockedUrlMaxCount
  );
  // get action from store
  const setWtpState = contextSelector((s) => s.setWtpState);
  // urls
  const addWtpApprovedUrls = contextSelector((s) => s.addWtpApprovedUrls);
  const removeWtpApprovedUrl = contextSelector((s) => s.removeWtpApprovedUrl);
  const addWtpBlockedUrls = contextSelector((s) => s.addWtpBlockedUrls);
  const removeWtpBlockedUrl = contextSelector((s) => s.removeWtpBlockedUrl);
  const importWtpApprovedUrls = contextSelector((s) => s.importWtpApprovedUrls);
  const importWtpBlockedUrls = contextSelector((s) => s.importWtpBlockedUrls);
  // local state
  const showInternalDomainCheckbox = React.useMemo(() => {
    // show internal domain checkbox in email policy
    return [
      PolicyTypeEnum.Exchange,
      PolicyTypeEnum.ExchangeInline,
      PolicyTypeEnum.Gmail,
      PolicyTypeEnum.GmailInline,
    ].includes(policyType);
  }, [policyType]);
  // approved url list
  // status change
  const handleWtpApprovedUrlListEnabledChange = React.useCallback(() => {
    setWtpState({
      wtpApprovedUrlListEnabled: wtpApprovedUrlListEnabled ? 0 : 1,
    });
  }, [wtpApprovedUrlListEnabled]);
  // internal domain change
  const handleWtpInternalDomainToApproveUrlChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setWtpState({
        wtpInternalDomainToApproveUrl: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  // export
  const handleApprovedUrlListExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-url-list',
    });
  }, []);
  // import
  const [isApprovedUrlImportModalVisible, setIsApprovedUrlImportModalVisible] =
    React.useState(false);
  const handleApprovedUrlImportModalClose = React.useCallback(() => {
    setIsApprovedUrlImportModalVisible(false);
  }, []);
  const handleApprovedUrlImportModalOpen = React.useCallback(() => {
    setIsApprovedUrlImportModalVisible(true);
  }, []);
  const handleApprovedUrlImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importWtpApprovedUrls(entries as string[]);
    setIsApprovedUrlImportModalVisible(false);
  }, []);
  // blocked url list
  // status change
  const handleWtpBlockedUrlListEnabledChange = React.useCallback(() => {
    setWtpState({
      wtpBlockedUrlListEnabled: wtpBlockedUrlListEnabled ? 0 : 1,
    });
  }, [wtpBlockedUrlListEnabled]);
  // export
  const handleBlockedUrlListExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'blocked-url-list',
    });
  }, []);
  // import
  const [isBlockedUrlImportModalVisible, setIsBlockedUrlImportModalVisible] =
    React.useState(false);
  const handleBlockedUrlImportModalClose = React.useCallback(() => {
    setIsBlockedUrlImportModalVisible(false);
  }, []);
  const handleBlockedUrlImportModalOpen = React.useCallback(() => {
    setIsBlockedUrlImportModalVisible(true);
  }, []);
  const handleBlockedUrlImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importWtpBlockedUrls(entries as string[]);
    setIsBlockedUrlImportModalVisible(false);
  }, []);
  useWhyDidYouUpdate('Urls', {
    wtpApprovedUrlListEnabled,
    wtpInternalDomainToApproveUrl,
    approvedUrlList,
    wtpBlockedUrlListEnabled,
    blockedUrlList,
    isApprovedUrlImportModalVisible,
    isBlockedUrlImportModalVisible,
  });
  return (
    <>
      <TitleLabel title={t('policy.approvedAndBlockedList.URLs')} />
      <Flex direction="column" ml="25px" mb="24px">
        <Flex alignItems="center" mb="3x">
          <FormLabel
            label={t('policy.approvedAndBlockedList.approvedUrl.title')}
            withColon={false}
            width="100%"
          />
          <Switch
            checked={!!wtpApprovedUrlListEnabled}
            value={wtpApprovedUrlListEnabled}
            onChange={handleWtpApprovedUrlListEnabledChange}
          />
          <Text ml="3x" fontSize="14px" lineHeight="20px">
            {wtpApprovedUrlListEnabled
              ? t('common.label.on')
              : t('common.label.off')}
          </Text>
        </Flex>
        {showInternalDomainCheckbox ? (
          <Flex alignItems="center" mb="3x">
            <Checkbox
              checked={!!wtpInternalDomainToApproveUrl}
              onChange={handleWtpInternalDomainToApproveUrlChange}
              value={wtpInternalDomainToApproveUrl}
              disabled={!wtpApprovedUrlListEnabled}
              name="wtpInternalDomainToApproveUrl"
            >
              {t('policy.approvedAndBlockedList.approvedUrl.desc')}
            </Checkbox>
          </Flex>
        ) : null}
        <EditableList
          onDelete={removeWtpApprovedUrl}
          onAdd={addWtpApprovedUrls}
          onExport={handleApprovedUrlListExport}
          onImport={handleApprovedUrlImportModalOpen}
          list={approvedUrlList}
          disabled={!wtpApprovedUrlListEnabled}
          limit={blockedUrlMaxCount}
          description={''}
          width={'800px'}
          size={4}
          placeholder={t('policy.placeholder.url')}
        />
      </Flex>
      <FormList
        onAdd={addWtpBlockedUrls}
        onDelete={removeWtpBlockedUrl}
        onExport={handleBlockedUrlListExport}
        onImport={handleBlockedUrlImportModalOpen}
        list={blockedUrlList}
        limit={blockedUrlMaxCount}
        status={!!wtpBlockedUrlListEnabled}
        setStatus={handleWtpBlockedUrlListEnabledChange}
        label={t('policy.approvedAndBlockedList.blockedUrl')}
        placeholder={t('policy.placeholder.url')}
      />
      <Flex alignItems="center" ml="25px" mb="3x">
        <Text p="0px 0px 20px 0px">
          <Space fontSize="semibold">{t('common.label.note')}:</Space>
          <Space width="2x"></Space>
          <Space>
            <Trans
              i18nKey={`policy.WebReputation.ApprovedUrlList.note`}
              values={{
                name:
                  customConfig.ui.featureToggle.whiteLabelingFeatureToggle &&
                  customConfig.ui.deployRegion === 'uaenorth'
                    ? customConfig.ui.feature.whiteLabeling.fullName
                    : t('policy.WebReputation.ApprovedUrlList.name'),
              }}
            >
              placeholder
              <Link
                m="0 5px"
                href="http://global.sitesafety.trendmicro.com"
                target="_blank"
              >
                placeholder
              </Link>
              placeholder
            </Trans>
          </Space>
        </Text>
      </Flex>
      <ImportModal
        isVisible={isApprovedUrlImportModalVisible}
        onClose={handleApprovedUrlImportModalClose}
        onImport={handleApprovedUrlImport}
      />
      <ImportModal
        isVisible={isBlockedUrlImportModalVisible}
        onClose={handleBlockedUrlImportModalClose}
        onImport={handleBlockedUrlImport}
      />
    </>
  );
};
export const WtpHeaderFields = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const { t } = useTranslation();
  // get state from store
  // header fields
  const wtpApprovedHeaderEnabled = policySelector(
    (s) => s.tmWebthreatprotections.wtpApprovedHeaderEnabled
  );
  const approvedHeaderList = contextSelector(
    wtpApprovedHeaderListSelector,
    isEqual
  );
  // config
  const approvedHeaderMaxNumber = contextSelector(
    (s) => s.config.limitation.approvedHeaderMaxNumber
  );
  const approvedHeaderMaxLength = contextSelector(
    (s) => s.config.limitation.approvedHeaderMaxLength
  );
  // get action from store
  const setWtpState = contextSelector((s) => s.setWtpState);
  // header fields
  const addWtpApprovedHeader = contextSelector((s) => s.addWtpApprovedHeader);
  const removeWtpApprovedHeader = contextSelector(
    (s) => s.removeWtpApprovedHeader
  );
  // local state
  // approved header list
  const handleWtpApprovedHeaderEnabledChange = React.useCallback(() => {
    setWtpState({ wtpApprovedHeaderEnabled: wtpApprovedHeaderEnabled ? 0 : 1 });
  }, [wtpApprovedHeaderEnabled]);
  const operators = React.useMemo(() => {
    return [
      { value: HeaderOperatorEnum.equals, name: t('common.label.equals') },
      { value: HeaderOperatorEnum.contains, name: t('common.label.contains') },
    ];
  }, []);
  useWhyDidYouUpdate('HeaderFields', {
    wtpApprovedHeaderEnabled,
    approvedHeaderList,
  });
  return (
    <>
      <TitleLabel title={t('policy.headerFields.title')} />
      <FormHeaderFieldList
        onAdd={addWtpApprovedHeader}
        onDelete={removeWtpApprovedHeader}
        list={approvedHeaderList}
        limit={approvedHeaderMaxNumber}
        headerMaxLength={approvedHeaderMaxLength}
        status={!!wtpApprovedHeaderEnabled}
        setStatus={handleWtpApprovedHeaderEnabledChange}
        label={t('policy.headerFields.desc')}
        operators={operators}
      />
    </>
  );
};

export const WtpTocFields = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [
    isTocApprovedUrlImportModalVisible,
    setIsTocApprovedUrlImportModalVisible,
  ] = React.useState(false);
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const { t } = useTranslation();
  // get state from store
  const wtpTocApprovedUrlListEnabled = policySelector(
    (s) => s.tmWebthreatprotections.wtpTocApprovedUrlListEnabled
  );
  const tocApprovedUrlList = contextSelector(
    wtpTocApprovedUrlListSelector,
    isEqual
  );
  // config
  const tocApprovedUrlMaxCount = contextSelector(
    (s) => s.config.limitation.tocApprovedListMaxCount
  );
  // get action from store
  const setWtpState = contextSelector((s) => s.setWtpState);
  const addWtpTocApprovedUrls = contextSelector((s) => s.addWtpTocApprovedUrls);
  const removeWtpTocApprovedUrls = contextSelector(
    (s) => s.removeWtpTocApprovedUrls
  );
  const importWtpTocApprovedUrls = contextSelector(
    (s) => s.importWtpTocApprovedUrls
  );

  const handleWtpTocApprovedUrlEnabledChange = React.useCallback(() => {
    setWtpState({
      wtpTocApprovedUrlListEnabled: wtpTocApprovedUrlListEnabled ? 0 : 1,
    });
  }, [wtpTocApprovedUrlListEnabled]);

  const handleWtpTocApprovedUrlImportModalClose = React.useCallback(() => {
    setIsTocApprovedUrlImportModalVisible(false);
  }, []);

  const handleWtpTocApprovedUrlModalOpen = React.useCallback(() => {
    setIsTocApprovedUrlImportModalVisible(true);
  }, []);

  const handleWtpTocApprovedUrlImport = React.useCallback((entries: any) => {
    importWtpTocApprovedUrls(entries as string[]);
    setIsTocApprovedUrlImportModalVisible(false);
  }, []);

  const handleWtpTocApprovedUrlExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'toc-approved-url-list',
    });
  }, []);

  useWhyDidYouUpdate('Toc Approved Fields', {
    wtpTocApprovedUrlListEnabled,
    tocApprovedUrlList,
  });
  return (
    <>
      <TitleLabel
        title={t('policy.approvedAndBlockedList.TocApprovedURLs.title')}
      />
      <Text mt="12px" mb="12px" color={colorStyle.color.secondary}>
        {t('policy.approvedAndBlockedList.TocApprovedURLs.desc')}
      </Text>
      <FormList
        onAdd={addWtpTocApprovedUrls}
        onDelete={removeWtpTocApprovedUrls}
        onExport={handleWtpTocApprovedUrlExport}
        onImport={handleWtpTocApprovedUrlModalOpen}
        list={tocApprovedUrlList}
        limit={tocApprovedUrlMaxCount}
        status={!!wtpTocApprovedUrlListEnabled}
        setStatus={handleWtpTocApprovedUrlEnabledChange}
        label={t('policy.approvedAndBlockedList.TocApprovedURLs.switch')}
        placeholder={t('policy.placeholder.url')}
      />
      <ImportModal
        isVisible={isTocApprovedUrlImportModalVisible}
        onClose={handleWtpTocApprovedUrlImportModalClose}
        onImport={handleWtpTocApprovedUrlImport}
      />
    </>
  );
};

function ApproveBlockList({
  headerFieldsShow = true,
  urlsShow = true,
  sendersShow = true,
  tocProtectionShow = false,
}: {
  headerFieldsShow?: boolean;
  urlsShow?: boolean;
  sendersShow?: boolean;
  tocProtectionShow?: boolean;
}) {
  return (
    <div>
      <Box ml="1px" mt="34px">
        <Flex direction="column">
          {sendersShow ? <WtpSenders /> : null}
          {urlsShow ? <WtpUrls /> : null}
          {headerFieldsShow ? <WtpHeaderFields /> : null}
          {tocProtectionShow ? <WtpTocFields /> : null}
        </Flex>
      </Box>
    </div>
  );
}

export default React.memo(ApproveBlockList);
